<template>
  <div class="pt-3">
    <div class="container-fluid">
      <b-card class="px-5 card-form">
        <template v-for="(i, index) in formFields">
          <div class="text-left" :key="index">
            <b-row
              no-gutters
              :class="`align-items-${index == 3 ? 'start' : 'center'} pb-4`"
            >
              <b-col cols="3" class="text-capitalize font-size-base">
                {{ $t(`label.${i.title}`)
                }}<span class="text-danger pl-1">*</span></b-col
              >
              <b-col md="5" lg="4" class="">
                <component
                  v-if="i.layout"
                  v-model="$v.rolePermissionObj[i.model].$model"
                  :state="validateObjState('rolePermissionObj', i.model)"
                  :validators="i.validators"
                  :validationParams="i.validationParams"
                  :validationValue="$v.rolePermissionObj[i.model]"
                  :is="i.layout"
                  :options="i.options"
                ></component>
                <AppFormField
                  v-else
                  v-model="$v.rolePermissionObj[i.model].$model"
                  :state="validateObjState('rolePermissionObj', i.model)"
                  :size="i.size"
                  :customStyle="i.customStyle"
                  :validators="i.validators"
                  :validationParams="i.validationParams"
                  :validationValue="$v.rolePermissionObj[i.model]"
                  :formType="i.formType"
                  :options="i.options"
                  solid
                  horizontal
                >
                </AppFormField>
              </b-col>
            </b-row>
          </div>
        </template>
        <hr class="my-0 pb-3" />
        <button
          :disabled="
            !checkAccessRight(moduleName, [
              isCreate ? action.PERMISSIONS_CREATE : action.PERMISSIONS_UPDATE,
            ])
          "
          class="btn btn-primary btn-fill float-right text-capitalize font-size-base"
          @click="submitPermission(id)"
        >
          {{ $t(`${isCreate ? "label.create" : "label.save"}`) }}
        </button>
        <button
          v-if="!isCreate"
          :disabled="!checkAccessRight(moduleName, [action.PERMISSIONS_DELETE])"
          class="btn btn-danger btn-fill float-right text-capitalize mr-3 font-size-base"
          @click="deletePermissionModal(id)"
        >
          {{ $t(`label.delete`) }}
        </button>
      </b-card>
    </div>
  </div>
</template>
<script>
import AppFormField from "@/views/components/bases/form-field/AppFormField.vue";
import PermissionCheckBox from "@/views/components/role-permission/PermissionCheckBox.vue";
import commonMixin from "@/core/mixins/common.mixin";
import { listService } from "@/core/services";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { i18nHelper } from "@/core/utils";
import { MODULE, ACTION, ROUTE_NAME } from "@/core/constants";
import {
  ROLE_PERMISSION_GET_PERMISSION,
  ROLE_PERMISSION_CREATE_PERMISSION,
  ROLE_PERMISSION_UPDATE_PERMISSION,
  ROLE_PERMISSION_DELETE_PERMISSION,
  ROLE_PERMISSION_INITIAL_GET_PERMISSION_STATE,
  ROLE_PERMISSION_INITIAL_CREATE_PERMISSION_STATE,
  ROLE_PERMISSION_INITIAL_UPDATE_PERMISSION_STATE,
  ROLE_PERMISSION_INITIAL_DELETE_PERMISSION_STATE,
} from "@/core/store/role-permission.module";
import {
  AUTH_GET_PERMISSION,
  AUTH_INITIAL_GET_PERMISSION_STATE,
} from "@/core/store/auth.module";

export default {
  name: "RolePermissionForm",
  mixins: [commonMixin, validationMixin],
  components: {
    AppFormField,
    PermissionCheckBox,
  },
  props: {
    isCreate: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    moduleName: MODULE.PERMISSIONS,
    action: ACTION,
    formFields: [],
    rolePermissionObj: {
      id: null,
      roleName: null,
      adGroupName: null,
      status: 0,
      modules: [""],
    },
  }),
  created() {},
  mounted() {
    this.initialPermission();
  },
  computed: {
    getAuthPermissionComplate() {
      return this.$store.state.auth.getPermission.complete;
    },

    id() {
      return this.$route.params.id;
    },
    getPermissionComplate() {
      return this.$store.state.rolePermission.permission.complete;
    },
    createPermissionComplate() {
      return this.$store.state.rolePermission.createPermission.complete;
    },
    updatePermissionComplate() {
      return this.$store.state.rolePermission.updatePermission.complete;
    },
    deletePermissionComplate() {
      return this.$store.state.rolePermission.deletePermission.complete;
    },
  },
  watch: {
    getAuthPermissionComplate() {
      let response = this.$store.state.auth.getPermission;
      if (response.complete) {
        this.authComplateAction();
      }
    },

    getPermissionComplate() {
      let response = this.$store.state.rolePermission.permission;
      if (response.complete) {
        this.rolePermissionObj = response.data;
        this.permissionComplateAction(response, "get");
      }
    },
    createPermissionComplate() {
      let response = this.$store.state.rolePermission.createPermission;
      if (response.complete) {
        this.permissionComplateAction(response, "create");
      }
    },
    updatePermissionComplate() {
      let response = this.$store.state.rolePermission.updatePermission;
      if (response.complete) {
        this.permissionComplateAction(response, "update");
      }
    },
    deletePermissionComplate() {
      let response = this.$store.state.rolePermission.deletePermission;
      if (response.complete) {
        this.permissionComplateAction(response, "delete");
      }
    },
  },
  methods: {
    authComplateAction() {
      this.initialGetAuthPermission();
    },
    getAuthPermission() {
      this.$store.dispatch(AUTH_GET_PERMISSION, {});
    },
    initialGetAuthPermission() {
      this.$store.dispatch(AUTH_INITIAL_GET_PERMISSION_STATE, {});
    },

    permissionComplateAction(response, actionType) {
      let title = i18nHelper.getMessage("label.rolePermission");
      let messages = response.message;
      let code = response.code;
      let buttons = [];

      switch (actionType) {
        case "get":
          if (code == 200) {
            this.initFormFields();
          }
          this.initialGetPermission();
          break;
        case "create":
          if (code == 200) {
            this.getAuthPermission();
          }
          this.initialCreatePermission();
          break;
        case "update":
          if (code == 200) {
            this.getAuthPermission();
          }
          this.initialUpdatePermission();
          break;
        case "delete":
          if (code == 200) {
            this.getAuthPermission();
          }
          this.initialDeletePermission();
          break;
      }
      if (response.code == 200) {
        buttons.push({
          text: i18nHelper.getMessage("label.ok"),
          variant: "primary",
          action: () => {
            this.closeLayoutAppModalInfo();
            switch (actionType) {
              case "create":
                this.$router.push({
                  name: ROUTE_NAME.ROLE_PERMISSION_DETAILS,
                  params: { id: response.data.id },
                });
                break;
              case "update":
                this.$children[3].$refs.tree1.checkedNodes = [];
                this.getPermission(this.id);
                break;
              case "delete":
                this.$router.push({
                  name: ROUTE_NAME.ROLE_PERMISSION_LIST,
                });
                break;
              default:
                this.getPermission(this.id);
            }
          },
        });
      } else {
        buttons.push({
          text: i18nHelper.getMessage("label.ok"),
          variant: "primary",
          action: () => {
            this.closeLayoutAppModalInfo();
            this.getPermission(this.id);
          },
        });
      }
      if (messages) this.openLayoutAppModalInfo(title, messages, buttons, code);
    },
    initFormFields() {
      this.formFields = [
        {
          model: "roleName",
          title: "roleName",
          validators: ["required"],
        },
        {
          model: "adGroupName",
          title: "adGroupName",
          validators: ["required"],
        },
        {
          model: "status",
          title: "status",
          formType: "singleCheckbox",
          options: [
            { value: 0, text: "Active" },
            { value: 1, text: "Inactive" },
          ],
          validators: [],
          customStyle: "transform: scale(1.5, 1.5);margin-left: 7px;",
        },
        {
          model: "modules",
          title: "modules",
          layout: "permissionCheckBox",
          options: listService.getPermissionModules(
            this.rolePermissionObj.modules
          ),
        },
      ];
    },
    submitPermission(id) {
      if (this.validationCheck("rolePermissionObj")) {
        let data = this.rolePermissionObj;
        if (this.isCreate) {
          this.$store.dispatch(ROLE_PERMISSION_CREATE_PERMISSION, { data });
        } else {
          this.$store.dispatch(ROLE_PERMISSION_UPDATE_PERMISSION, { id, data });
        }
        this.resetForm();
      }
    },
    resetForm() {
      this.rolePermissionObj = {
        id: null,
        roleName: null,
        adGroupName: null,
        status: 0,
        modules: null,
      };
      this.$v.$reset();
    },
    initialPermission() {
      let breadcrumbData = {
        breadcrumbs: [
          {
            title: i18nHelper.getMessage("label.rolePermission"),
            route: { name: ROUTE_NAME.ROLE_PERMISSION_LIST },
          },
          {
            title: i18nHelper.getMessage("label.rolePermissionDetails"),
          },
        ],
      };
      this.initBreadCrumb(breadcrumbData);
      if (!this.isCreate) {
        this.getPermission(this.id);
      } else {
      }
      this.initFormFields();
    },
    deletePermissionModal() {
      let title = i18nHelper.getMessage("label.rolePermission");
      let messages = [
        i18nHelper.getMessage("message.requestDeleteMessage", [
          i18nHelper.getMessage("label.rolePermission"),
        ]),
      ];
      let buttons = [];

      buttons.push(
        {
          text: i18nHelper.getMessage("label.cancel"),
          variant: "white",
          action: () => {
            this.closeLayoutAppModalInfo();
          },
        },
        {
          text: i18nHelper.getMessage("label.delete"),
          variant: "danger",
          action: () => {
            this.deletePermission(this.id);
          },
        }
      );

      if (messages) this.openLayoutAppModalInfo(title, messages, buttons);
    },
    getPermission(id) {
      this.$store.dispatch(ROLE_PERMISSION_GET_PERMISSION, { id });
    },
    createPermission(data) {
      this.$store.dispatch(ROLE_PERMISSION_CREATE_PERMISSION, { data });
    },
    updatePermission(id, data) {
      this.$store.dispatch(ROLE_PERMISSION_UPDATE_PERMISSION, { id, data });
    },
    deletePermission(id) {
      this.$store.dispatch(ROLE_PERMISSION_DELETE_PERMISSION, { id });
    },
    initialGetPermission() {
      this.$store.dispatch(ROLE_PERMISSION_INITIAL_GET_PERMISSION_STATE, {});
    },
    initialCreatePermission() {
      this.$store.dispatch(ROLE_PERMISSION_INITIAL_CREATE_PERMISSION_STATE, {});
    },
    initialUpdatePermission() {
      this.$store.dispatch(ROLE_PERMISSION_INITIAL_UPDATE_PERMISSION_STATE, {});
    },
    initialDeletePermission() {
      this.$store.dispatch(ROLE_PERMISSION_INITIAL_DELETE_PERMISSION_STATE, {});
    },
  },
  validations: {
    rolePermissionObj: {
      roleName: { required },
      adGroupName: { required },
      status: {},
      modules: {},
    },
  },
};
</script>

<style></style>
